import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import QueryString from "qs";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { ReqMethods, ghl } from "enums";
import env from "config/env";
import useRequest from "hook/useRequest";
import { useAgencyInfo } from "context/agency";
// import { AgencyContext } from '../../../context/Agency.context'

function GHL() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const code = new URLSearchParams(search).get("code");
  const type = new URLSearchParams(search).get("type");
  const request = useRequest();
  const queryClient = useQueryClient();

  const searchParams = new URLSearchParams(document.location.search);
  const agency = searchParams.get("state");
  // alert(agency);
  const associate = async (creds) => {
    const payload = {
      _id: agency,
      agency_ghl: {
        company_id: creds.companyId,
        access_token: creds.access_token,
        refresh_token: creds.refresh_token,
      },
    };

    const { response } = await request(ReqMethods.PUT, "/brand", { payload });

    if (!response) throw new Error("Something went wrong while integration, please try latter");
    // update(payload);
    return "agency SuccessFully connected";
  };

  // const getLocation = async (creds) => {
  //   const payload = {
  //     method: ReqMethods.GET,
  //     path: `${ghl.APIs.v2.location(creds.locationId)}`,
  //     key: creds.access_token,
  //     refresh_token: creds.refresh_token,
  //   }
  //   const { response } = await AppServices.services.ghl.call_service({ payload })

  //   if (!response) return setError('Something went wrong while integration, please try latter')

  //   return response && associate(response.data, creds)
  // }

  const getCreds = async () => {
    const payload = {
      method: ReqMethods.POST,
      path: ghl.APIs.oauth,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      payload: QueryString.stringify({
        client_id: env.GHL.CLIENT_ID,
        client_secret: env.GHL.CLIENT_SECRET,
        grant_type: "authorization_code",
        code,
        refresh_token: "",
      }),
    };
    const { response } = await request(ReqMethods.POST, "/services/ghl/", { payload });

    if (!response) throw new Error("Something went wrong while integration, please try latter");

    return associate(response.data);
  };

  const { mutate, data, error, isError } = useMutation({
    mutationFn: getCreds,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["agency"] }),
  });

  const onLoad = () => {
    // mutate();
  };

  useEffect(onLoad, []);

  const done = isError || !!data;

  return (
    <SoftBox>
      {!done && <SoftBox>Integrating please wait...</SoftBox>}
      {done && (
        <SoftBox>
          {isError ? error.message : data}
          <SoftButton onClick={() => navigate(-2)}>Go Back</SoftButton>
        </SoftBox>
      )}
    </SoftBox>
  );
}

export default GHL;
